import { Injectable } from '@angular/core';
import { ChatAgent, TabsInterface, SystemUser, RoomMember, UserDetails } from '../model/user-interfaces';
import { AuthService } from './auth.service';
import { ChatMentionUser, ChatMessage, Pagination, Room } from '../model/chat.message';
import { ChatFile } from '../model/attchment-chat.modal';
import { RESET_PAGINATOR } from 'src/app/constants/constants';
import { FormControl, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class VariableService {
  chatMessages: ChatMessage[] = [];
  pagination: Pagination = RESET_PAGINATOR(null, 100);
  paginationChatHistory: Pagination = RESET_PAGINATOR(null, 100);
  chatHistoryMessagesLoading = false;
  agentList: ChatAgent[] = [];
  searchTerm = '';
  user: SystemUser;
  dummyImage = 'assets/custom-images/dummyImg.png';
  liveRooms: Room[] = [];
  unAssignedRooms: Room[] = [];
  mentionedRooms: Room[] = [];
  mentionUsers: ChatAgent[] = [];
  mentionArray: ChatMentionUser[] = [];
  images: ChatFile[] = [];
  selectedChat: Room;
  background = '';
  textColor = '';
  openTab: TabsInterface = "live";
  users: Room[] = [];
  usersLoading = true;
  messagesLoading = false;
  loadMoreMessages = false;
  isAtTop = false;
  pdfs: ChatFile[] = [];
  chatText = '';
  totalAgents: number = 0;
  onlineAgents: number = 0;
  busyAgents: number = 0;
  offlineAgents: number = 0;
  members: RoomMember[] = [];
  avatars: { [key: string]: string } = {};
  agentPage = 1;
  apiLoading = false;
  moreUsers = false;
  isAgentChatHistory: boolean = false;
  userDetails: UserDetails = null;
  closeRoomLoader = false;

  colorPairs = [
    { background: "#EAEDFF", text: "#B7B1F2" },
    { background: "#FEE4FF", text: "#FDB7EA" },
    { background: "#FFF4DE", text: "#FFDC96" },
    { background: "#E0F7FF", text: "#8FE2FF" },
    { background: "#FFE2EA", text: "#FF9CB8" },
    { background: "#FFECE1", text: "#FFC29E" },
    { background: "#DFF9E0", text: "#A8D2AA" },
    { background: "#E1F0F8", text: "#9DC6DA" },
    { background: "#F0F0F0", text: "#B9C1C4" },
    { background: "#E6EEFF", text: "#A4C1FF" },
    { background: "#E1F2F4", text: "#8FD2DB" },
    { background: "#FFF6E4", text: "#E0D1B3" },
  ];

  constructor(private authService: AuthService) {
    this.user = this.authService.getUser()?.user;
  }

  pickColorIndex(identifier: string | number): number {
    const id = typeof identifier === 'string' ? this.hashString(identifier) : identifier;
    return Math.abs(id) % this.colorPairs.length;
  }

  private hashString(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }


  getBackgroundColor(identifier: string): string {
    const index = this.pickColorIndex(identifier);
    return this.colorPairs[index]?.background || "";
  }

  get roomId() {
    return this.selectedChat?.roomId;
  }

  getTextColor(identifier: string): string {
    const index = this.pickColorIndex(identifier);
    return this.colorPairs[index]?.text || "";
  }

  get chatContainerId() {
    return 'autoResizeTextArea';
  }

  get chatContainerElement() {
    return document.getElementById(this.chatContainerId);
  }

  // setAgents(arr: ChatAgent[]) {
  //   this.agentList = arr;
  // }

  // get agentList() {
  //   return this.searchTerm?.length ? this.mentionUsers : this.chatAgentList;
  // }

}
